import { useClassManageStore } from '@/features/class/manage/classManageStore';
import type { ClassTabId } from '@/features/class/types';
import {
  CLASS_EMPTY_ADMIN_CODE,
  CLASS_EMPTY_MEMBER_CODE,
  CLASS_EMPTY_OWNER_CODE,
} from '@/features/class/classEmptyPreview';

export interface ClassCatalogEntry {
  readonly code: string;
  readonly name: string;
  readonly dotClassName: string;
}

const BIO202_ENTRY = {
  code: CLASS_EMPTY_MEMBER_CODE,
  name: 'BIO 202 - Genetics',
  dotClassName: 'bg-[#60a5fa]',
} as const satisfies ClassCatalogEntry;

const PSYC101_ENTRY = {
  code: CLASS_EMPTY_OWNER_CODE,
  name: 'PSYC 101 - Intro Psychology',
  dotClassName: 'bg-[#c084fc]',
} as const satisfies ClassCatalogEntry;

const HIST301_ENTRY = {
  code: CLASS_EMPTY_ADMIN_CODE,
  name: 'HIST 301 - American History',
  dotClassName: 'bg-[#f472b6]',
} as const satisfies ClassCatalogEntry;

export const CLASS_CATALOG: readonly ClassCatalogEntry[] = [
  { code: 'CS101', name: 'CS 101 - Intro to CS', dotClassName: 'bg-[#f87171]' },
  { code: 'MATH201', name: 'MATH 201 - Calculus II', dotClassName: 'bg-[#fb923c]' },
  { code: 'ENG105', name: 'ENG 105 - Literature', dotClassName: 'bg-[#fbbf24]' },
  { code: 'PHYS301', name: 'PHYS 301 - Quantum', dotClassName: 'bg-[#34d399]' },
  BIO202_ENTRY,
  PSYC101_ENTRY,
  HIST301_ENTRY,
] as const;

export const OWNED_CLASSES: readonly ClassCatalogEntry[] = [
  CLASS_CATALOG[0],
  CLASS_CATALOG[1],
  PSYC101_ENTRY,
];

export const JOINED_CLASSES: readonly ClassCatalogEntry[] = [
  CLASS_CATALOG[2],
  CLASS_CATALOG[3],
  BIO202_ENTRY,
  HIST301_ENTRY,
];

export const DEFAULT_CLASS_CODE = 'CS101' as const;

const CLASS_TAB_IDS: readonly ClassTabId[] = [
  'posts',
  'members',
  'roster',
  'attendance',
  'progress',
  'behaviour',
  'grades',
  'calendar',
  'resources',
];

export function getClassByCode(classCode: string): ClassCatalogEntry | undefined {
  const normalized = classCode.toUpperCase();
  const fromCatalog = CLASS_CATALOG.find((entry) => entry.code.toUpperCase() === normalized);
  if (fromCatalog) {
    return fromCatalog;
  }
  const managed = useClassManageStore.getState().getManagedClassByCode(classCode);
  if (!managed) {
    return undefined;
  }
  return {
    code: managed.code,
    name: managed.name,
    dotClassName: managed.dotClassName,
  };
}

export function isClassTabId(value: string | undefined): value is ClassTabId {
  if (!value) {
    return false;
  }
  return (CLASS_TAB_IDS as readonly string[]).includes(value);
}
